var $ = require('jquery');
var _ = require('lodash');
var stats = require('stats/stats');

var platform = null;
var adID = null;

var buildURL = function (bannerType, func) {
    // Not all browsers support location.origin
    var baseURL = (window.location.origin || document.location.origin);
    language = readActLang("django_language")
    return baseURL + "/" + language + "/" + bannerType + "/" + func + "/" + adID + "/" + platform + "/";
};

var registerBannerClick = function (bannerType) {
    $.get(buildURL(bannerType, 'click'));
};

var registerBannerView = function (bannerType) {
    $.get(buildURL(bannerType, 'view'));
};

var isMobileSize = function () {
    // This includes scrollbar and is not the most
    // accurate calculation anyway, but close enough.
    var w = window.innerWidth
        || document.documentElement.clientWidth
        || document.body.clientWidth;
    return w < 640;
};

$(function () {
    platform = isMobileSize() ? 'm' : 'd';

    let viewsRegistered = {};

    // Parade
    const paradeAds = $('.parade-ad');
    if (paradeAds.length > 0) {
      adID = $('.parade-ad').eq(0).data('id');
      registerBannerView('parade_ad');
      const adKey = 'parade' + adID;
      viewsRegistered[adKey] = true;
    }
    if (window.splide && paradeAds.length > 0) {
      window.splide.on('moved', (newIndex, prevIndex, destIndex) => {
          // GET correct image data-attrs
          adID = $('.parade-ad').eq(newIndex).data('id');
          const adKey = 'parade' + adID;
          if (!(adKey in viewsRegistered)) {
            // Register views
            registerBannerView('parade_ad');
            viewsRegistered[adKey] = true;
          }
      });
    }

    $('.parade-ad').on('click', function() {
      adID = $(this).data('id');
      registerBannerClick('parade_ad');
    });

    // Page
    const pageAds = $('.page-ad');
    if (pageAds.length > 0) {
      adID = $('.page-ad').eq(0).data('id');
      registerBannerView('page_ad');
      const adKey = 'page' + adID;
      viewsRegistered[adKey] = true;
    }
    if (window.splide && pageAds.length > 0) {
      window.splide.on('moved', (newIndex, prevIndex, destIndex) => {
          adID = $('.page-ad').eq(newIndex).data('id');
          const adKey = 'page' + adID;
          if (!(adKey in viewsRegistered)) {
            // Register views
            registerBannerView('page_ad');
            viewsRegistered[adKey] = true;
          }
      });
    }

    $('.page-ad').on('click', function() {
      adID = $(this).data('id');
      registerBannerClick('page_ad');
    });

    // Index
    $('.index-ad').each(function() {
      adID = $(this).data('id');
      registerBannerView('index_ad');
    });

    $('.index-ad').on('click', function() {
      adID = $(this).data('id');
      registerBannerClick('index_ad');
    });

    // Game
    $('.game-ad').each(function() {
      adID = $(this).data('id');
      registerBannerView('game_ad');
    });

    $('.game-ad').on('click', function() {
      adID = $(this).data('id');
      registerBannerClick('game_ad');
    });


    // Sponsors
    $('.bottom-sponsors').each(function() {
      adID = -1;
      registerBannerView('sponsor_ad');
    });

    $('.bottom-sponsor-logo').on('click', function() {
      adID = $(this).data('id');
      registerBannerClick('sponsor_ad');
    });

    $('.index-sponsor-logo').each(function() {
      adID = $(this).data('id');
      registerBannerView('adbanner');
    });

    $('.index-sponsor-logo').on('click', function() {
      adID = $(this).data('id');
      registerBannerClick('adbanner');
    });

});



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/common/js/ad_banner_all.js
// module id = 18
// module chunks = 23